function initCategoryCarousel(root) {
  const track = root.querySelector('.category-carousel__track');
  const slides = Array.from(root.querySelectorAll('.category-carousel__slide'));
  const prevBtn = root.querySelector('.category-carousel__arrow--prev');
  const nextBtn = root.querySelector('.category-carousel__arrow--next');
  const dotsWrap = root.querySelector('.category-carousel__dots');
  const counterCurrent = root.querySelector('.category-carousel__counter-current');
  const counterTotal = root.querySelector('.category-carousel__counter-total');

  if (!track || slides.length === 0) return;

  const autoscroll = root.dataset.autoscroll === 'true';
  const loop = root.dataset.loop === 'true';
  const speed = parseInt(root.dataset.speed, 10) || 4000;
  const perViewDesktop = parseInt(root.dataset.perView, 10) || 6;

  let currentIndex = 0;
  let timer = null;

  function visibleCount() {
    if (window.matchMedia('(max-width: 749px)').matches) return 2.5;
    if (window.matchMedia('(max-width: 989px)').matches) return 3;
    return perViewDesktop;
  }

  function maxIndex() {
    return Math.max(0, Math.ceil(slides.length - visibleCount()));
  }

  function buildDots() {
    if (!dotsWrap) return;
    dotsWrap.innerHTML = '';
    const count = maxIndex() + 1;
    for (let i = 0; i < count; i++) {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'category-carousel__dot';
      dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      dot.addEventListener('click', function () {
        go(i);
      });
      dotsWrap.appendChild(dot);
    }
    if (counterTotal) counterTotal.textContent = count;
  }

  function update() {
    const mi = maxIndex();
    if (currentIndex > mi) currentIndex = mi;
    if (currentIndex < 0) currentIndex = 0;

    const slideRect = slides[0].getBoundingClientRect();
    const trackStyles = window.getComputedStyle(track);
    const gap = parseFloat(trackStyles.gap) || 0;
    const offset = currentIndex * (slideRect.width + gap);

    track.style.transform = 'translateX(-' + offset + 'px)';

    if (prevBtn) prevBtn.disabled = !loop && currentIndex === 0;
    if (nextBtn) nextBtn.disabled = !loop && currentIndex === mi;

    if (dotsWrap) {
      Array.from(dotsWrap.children).forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === currentIndex);
      });
    }

    if (counterCurrent) counterCurrent.textContent = currentIndex + 1;
  }

  function go(index) {
    const mi = maxIndex();
    if (loop) {
      if (index < 0) index = mi;
      if (index > mi) index = 0;
      currentIndex = index;
    } else {
      currentIndex = Math.max(0, Math.min(index, mi));
    }
    update();
    if (autoscroll) {
      stopAuto();
      startAuto();
    }
  }

  function startAuto() {
    if (!autoscroll || maxIndex() === 0) return;
    stopAuto();
    timer = setInterval(function () {
      go(currentIndex + 1);
    }, speed);
  }

  function stopAuto() {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  }

  if (prevBtn) prevBtn.addEventListener('click', function () { go(currentIndex - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { go(currentIndex + 1); });

  root.addEventListener('mouseenter', stopAuto);
  root.addEventListener('mouseleave', startAuto);
  root.addEventListener('focusin', stopAuto);
  root.addEventListener('focusout', startAuto);

  let touchStartX = 0;
  root.addEventListener('touchstart', function (e) {
    touchStartX = e.touches[0].clientX;
    stopAuto();
  }, { passive: true });

  root.addEventListener('touchend', function (e) {
    const diff = e.changedTouches[0].clientX - touchStartX;
    if (Math.abs(diff) > 40) {
      diff > 0 ? go(currentIndex - 1) : go(currentIndex + 1);
    } else {
      startAuto();
    }
  }, { passive: true });

  window.addEventListener('resize', function () {
    buildDots();
    update();
  });

  buildDots();
  update();
  if (autoscroll) startAuto();
}

function initAllCategoryCarousels() {
  document.querySelectorAll('.category-carousel').forEach(function (el) {
    if (el.dataset.catInitialized) return;
    el.dataset.catInitialized = 'true';
    initCategoryCarousel(el);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllCategoryCarousels);
} else {
  initAllCategoryCarousels();
}

document.addEventListener('shopify:section:load', function (event) {
  const section = event.target.querySelector('.category-carousel');
  if (section && !section.dataset.catInitialized) {
    section.dataset.catInitialized = 'true';
    initCategoryCarousel(section);
  }
});